import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  IAddToBagConfirmModalModel,
  IAuthModalModel,
  ICartItemModalModel,
  IChangeRewardConfirmModalModel,
  IChangeStoreConfirmModalModel,
  ICommonModalModel,
  IReorderConfirmModalModel,
  ISocialLinkModalModel,
} from 'entities/UI/UI.models';

export interface IState {
  uiCommonModal: ICommonModalModel | null;
  uiAuthModal: IAuthModalModel | null;
  uiSocialLinkModal: ISocialLinkModalModel | null;
  uiReorderConfirmModal: IReorderConfirmModalModel | null;
  uiCartItemModal: ICartItemModalModel | null;
  uiChangeStoreConfirmModal: IChangeStoreConfirmModalModel | null;
  uiAddToBagConfirmModal: IAddToBagConfirmModalModel | null;
  uiChangeRewardConfirmModal: IChangeRewardConfirmModalModel | null;
  // MB-2754: gates ReferralRewardPopup — true once RewardsPopup's fate for the session is
  // settled (not eligible to show, or shown and manually closed), so the two popups never
  // overlap and always appear in a fixed order.
  isRewardsPopupResolved: boolean;
}

const initialState: IState = {
  uiCommonModal: { isVisible: false },
  uiAuthModal: { isVisible: false },
  uiSocialLinkModal: { isVisible: false },
  uiReorderConfirmModal: { isVisible: false },
  uiCartItemModal: { isVisible: false },
  uiChangeStoreConfirmModal: { isVisible: false },
  uiAddToBagConfirmModal: { isVisible: false },
  uiChangeRewardConfirmModal: { isVisible: false },
  isRewardsPopupResolved: false,
};

export const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setUiCommonModal(state, action: PayloadAction<ICommonModalModel>) {
      state.uiCommonModal = action.payload;
    },
    setUiAuthModal(state, action: PayloadAction<IAuthModalModel>) {
      state.uiAuthModal = action.payload;
    },
    setUiSocialLinkModal(state, action: PayloadAction<ISocialLinkModalModel>) {
      state.uiSocialLinkModal = action.payload;
    },
    setUiReorderConfirmModal(state, action: PayloadAction<IReorderConfirmModalModel>) {
      state.uiReorderConfirmModal = action.payload;
    },
    setUiCartItemModal(state, action: PayloadAction<ICartItemModalModel>) {
      state.uiCartItemModal = action.payload;
    },
    setUiChangeStoreConfirmModal(state, action: PayloadAction<IChangeStoreConfirmModalModel>) {
      state.uiChangeStoreConfirmModal = action.payload;
    },
    setUiAddToBagConfirmModal(state, action: PayloadAction<IAddToBagConfirmModalModel>) {
      state.uiAddToBagConfirmModal = action.payload;
    },
    setUiChangeRewardConfirmModal(state, action: PayloadAction<IChangeRewardConfirmModalModel>) {
      state.uiChangeRewardConfirmModal = action.payload;
    },
    setRewardsPopupResolved(state, action: PayloadAction<boolean>) {
      state.isRewardsPopupResolved = action.payload;
    },
  },
});

export const {
  setUiCommonModal,
  setUiAuthModal,
  setUiSocialLinkModal,
  setUiReorderConfirmModal,
  setUiCartItemModal,
  setUiChangeStoreConfirmModal,
  setUiAddToBagConfirmModal,
  setUiChangeRewardConfirmModal,
  setRewardsPopupResolved,
} = uiSlice.actions;
export default uiSlice.reducer;
